/**
 * Labstep
 *
 * @module core/Form/ReactForm/TextArea
 * @desc Editable textarea as a form field
 */

import { CustomTextWrapper as CustomFieldWrapper } from 'labstep-web/core/Form/ReactForm/CustomFieldWrapper';
import CoreTextArea from 'react-textarea-autosize';

export const TextArea = (props: any) => (
  <CustomFieldWrapper
    fieldElement={CoreTextArea}
    defaultValue=""
    {...props}
  />
);
